export default __webpack_public_path__ + "static/media/duplicate.42452932.svg";